@if (mode$|async; as mode) {
  @if (mode === 'Edit') {
    <app-add-button
      (appThrottledClick)="openRelationModal()"
      id="add-relation"
      class="mb-3">
    </app-add-button>
  }
  @if (relations$ | async; as relations) {
    @if (relations.length > 0) {
      <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 break-all">
        @for (relation of (relations$ | async); track relation) {
          <div class="rounded border border-neutral-3 p-6 flex flex-col shadow-sm relative">
            @if (mode === 'Edit' && !relation.readonly) {
              <div class="absolute right-4 top-4">
                <vwui-menu>
                  <vwui-menu-option data-test="menu-option-update" (click)="openRelationModal(relation)">Bewerken</vwui-menu-option>
                  <vwui-menu-option data-test="menu-option-delete" (click)="deleteRelation(relation)">Verwijderen</vwui-menu-option>
                </vwui-menu>
              </div>
            }
            <h3 class="relation-title" [class.pr-8]="mode === 'Edit' && !relation.readonly">
              <app-copy-to-clipboard [value]="relation.companyName">{{relation.companyName}}</app-copy-to-clipboard>
            </h3>
            <div>
              <span class="font-normal">({{relation.role.value}})</span>
            </div>
            <div class="my-3">
              <app-copy-to-clipboard value="{{relation | clipboardFormatRelationAddress}}">
                <div>{{relation.street}}</div>
                <div>{{relation.postalCode | appPostalCodeFormat}} {{relation.city}}</div>
              </app-copy-to-clipboard>
              <div>
                <app-copy-to-clipboard value="{{relation.phoneNumber | appPhoneNumberFormat}}">
                  {{relation.phoneNumber | appPhoneNumberFormat}}
                </app-copy-to-clipboard>
              </div>
            </div>
            @if (relation.contactPersonName !== '' && relation.contactPersonRole !== '') {
              <div class="flex items-center pt-2 mt-auto items-center"
                >
                <img src="assets/icons/user.svg">
                <app-copy-to-clipboard class="ml-2" value="{{relation.contactPersonName}} ({{relation.contactPersonRole}})">{{relation.contactPersonName}} ({{relation.contactPersonRole}})</app-copy-to-clipboard>
              </div>
            }
          </div>
        }
      </div>
    } @else {
      <vwui-empty-state
        messageTitle="Geen relaties"
      message="Er zijn nog geen relaties toegevoegd"></vwui-empty-state>
    }
  }
}
